module.exports = __webpack_public_path__ + "img/iconGongChengShengChanKaiGuan.3b5c06a3.svg";